import { BannerSliderEvents } from 'shared/constants/datalayer';
import { CypressVariables } from 'shared/cypress';
import { BannerData } from 'shared/types/cms';
import { isMobile } from 'shared/util/utility';
import { BannerItem } from './BannerItem';
import { LoaderSquare } from './LoaderSquare';

export const BannerSquare = ({ banner }: { banner?: BannerData }) => {
	const displayImage = isMobile() ? banner?.imageUrlMobile : banner?.imageUrl;
	const handleBannerClick = (banner: BannerData) => {
		BannerSliderEvents.NOT_LOGGED_CLICK_BANNER({ reg_alt: banner.imageAltText });
	};
	const alt = banner?.imageAltText || banner?.title;
	return (
		<section data-cy={CypressVariables.Banners} className={'w-full aspect-[524∶233] md:aspect-[10/3]'}>
			<LoaderSquare className={'z-1'} visible={!banner} />
			<BannerItem
				link={banner?.link}
				alt={alt}
				timed={banner?.isTimed}
				image={displayImage}
				onClick={() => banner && handleBannerClick(banner)}
			/>
		</section>
	);
};
